<template>
  <span>
    <CircleSvg v-if="!displayQuantity" :fill="statusColor" />
    &nbsp;
    <span v-if="displayQuantity" v-html='quantity.toLocaleString("en-US") + " In Stock"' :class='statusStyling'></span>
    <span :data-tooltip="'Call for quote 1-800-888-5223'" data-tooltip-position="top" v-else-if="!displayQuantity && statusLabel == 'Out Of Stock'" :class='statusStyling'>
      {{ statusLabel }}
    </span>
    <span v-else v-html='statusLabel' :class='statusStyling'></span>
  </span>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import CircleSvg from '../svg/CircleSvg.vue';

const props = defineProps({
  showQuantity: Boolean,
  quantity: Number,
  status: {
    type: String,
    default: ''
  },
  message: {
    type: String,
    default: ''
  },
});

const isAvailable = computed(() => {
  return props.status.toLowerCase() === 'available'
})

const statusLabel = computed(() => {
  if (isAvailable.value) return 'Available'
  return 'Out Of Stock'
})

const displayQuantity = computed(() => {
  return props.showQuantity && props.quantity > 1
})

const statusColor = computed(() => {
  if (isAvailable.value) return '#00AA2D'
  return '#C42424'
})

const statusStyling = computed(() => {
  if (isAvailable.value) return 'stock-available'
  return 'stock-inproduction'
})

</script>

<style lang='scss' scoped>
.stock-available {
  color: #00AA2D;
  font-weight: bold;
}

.stock-inproduction {
  color: #C42424;
  font-weight: bold;
}
</style>